"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.APP_ENDPOINT = {
    menu: 'app/menu-items?{{query}}',
};
